import { defineComponent } from 'vue'

import { storeToRefs } from '@sunrise/pinia'

import { useToastStore } from '../../ts/store/toastStoreModule/toastStoreModule'

import MsToastManager from '../MsToastManager/MsToastManager.vue'

export default defineComponent({
    name: 'MsGlobalToastManager',
    components: {
        MsToastManager,
    },
    setup() {
        const toastStore = useToastStore()
        const { toasts } = storeToRefs(toastStore)

        function removeId(id: number) {
            toastStore.removeToast(id)
        }

        function startTimeout(id: number) {
            toastStore.startTimeout(id)
        }

        function stopTimeout(id: number) {
            toastStore.stopTimeout(id)
        }

        return {
            removeId,
            toasts,
            startTimeout,
            stopTimeout,
        }
    },
})
